<template>
    <div class="group-news app">
        <div class="header-empty"></div>
        <div class="main-content">
            <breadItem :title1="breadTitle1" :title2="breadTitle2" :link1="breadLink1" :link2="breadLink2"></breadItem>
            <div class="editor">
                <div class="title-box tc">
                    <div class="title fs18 fwb color-blank">{{data.title}}</div>
                    <div class="time color-gray">{{formatTime.getMsecToSpecificTime(data.addtime,'yyyy年MM月dd日 hh:mm:ss')}}</div>
                    <div class="name">
                        <span :class="nameCss" v-if="data.type==1">{{data.group_name}}</span>
                        <span :class="nameCss" v-else>{{data.hospital_name}}</span>
                        <span :class="authorCss" v-if="data.author">作者：{{data.author}}</span>
                        <span class="color-gray" v-if="data.source">来源：{{data.source}}</span>
                    </div>
                </div>
                <div class="quill-editor">
                    <div class="ql-container ql-snow">
                        <div class="ql-editor contents" v-html="data.content"></div>
                    </div>
                </div>
            </div>
            <nav-top></nav-top>
        </div>
    </div>
</template>
<script>
import navTop from '@/components/top'
import breadItem from '@/components/breadItem'
import seoArgs from '../../utils/setSeoArgs';

export default {
    components: {
        navTop,
        breadItem
    },
    data() {
        return {
            data:'',
            name:this.$route.params.class,
            nameCss:'color-blue',
            authorCss:'color-gray',
            breadTitle1:'集团动态',
            breadTitle2: this.$route.params.class,
            breadLink1:'/dynamic/0.html',
            breadLink2:'/dynamic/'+ this.$route.params.dynamicId +'.html'
        };
    },
    computed: {

    },
    created() {
        this.$axios.post(this.api.dynamic.detail,{id:this.$route.params.id},res =>{
            this.data=res.data;
            res.data.name = '集团动态文章详情';
            seoArgs.setSeoArgs(res.data);

            if(this.data.author || this.data.source){
                this.nameCss = 'color-blue mr40';
            }

            if(this.data.source){
                this.authorCss = 'color-gray mr40';
            }
        },err =>{
            this.data=[];
        })
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        
    },
};
</script>
<style scoped>
    .editor{box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;margin-bottom:40px;padding-bottom:40px;}
    .title-box{padding:40px 0;}
    .title-box .title{line-height:25px;}
    .title-box .time{line-height:20px;margin:20px 0 10px 0;}
    .title-box .name{line-height:20px;}
    .contents{width:1120px;margin:0 auto 20px;word-break:break-all;}
    .contents img{max-width:100%;}
    .app .go-top{
        right:0;
        bottom:0px;
    }
</style>


// WEBPACK FOOTER //
// src/view/dynamic/detail.vue